export default __webpack_public_path__ + "media/images/iui/cancel-be869d3f28fc2358ff675f0b5539ebab.png";